import e, { useState as c, useEffect as b } from "react";
import f from "classnames";
import a from "./index160.mjs";
import { DATES_CONTAINER as n } from "./index161.mjs";
import { CollapsibleContainer as M } from "./index94.mjs";
import R from "./index131.mjs";
import { DatePicker as x } from "./index3.mjs";
import { AvailabilityInfo as L } from "./index162.mjs";
import { arrivalDateAtom as P, departureDateAtom as K, resetDatesAtom as V, restrictedDateClickedAtom as z, isEditSearchAtom as O } from "./index26.mjs";
import { useAtomValue as m, useSetAtom as B } from "jotai";
import { ClosedToDepartureAndMaxStayWarning as F, ClosedToDepartureAndMinStayWarning as H, ClosedToDepartureWarning as Y, ClosedToArrivalWarning as j, MaxStayWarning as q, MinStayWarning as G } from "./index163.mjs";
import { track as J } from "./index9.mjs";
import { TRACK_EVENT_TYPE as Q, TRACK_EVENT as U } from "./index10.mjs";
import { useHotelConfig as X } from "./index93.mjs";
import { getSubscriptionPlanRoot as Z } from "./index14.mjs";
const _e = ({
  expand: d,
  setExpand: s
}) => {
  const t = m(P), r = m(K), T = B(V), v = m(z), [u, _] = c(!0), [o, I] = c(0), [l, N] = c(0), [i, y] = c({ type: null }), p = m(O), { hotelId: E, propertySize: D, propertyType: g, subscriptionPlan: A } = X();
  b(() => {
    d !== void 0 && _(d);
  }, [d]), b(() => {
    u && t && r && !p ? (J(U.CLICK, Q.CALENDAR_DATES_SELECTED, {
      hotel_id: E,
      property_type: g,
      property_size: D,
      subscription_plan: Z(A)
    }), s(!1)) : (!t || !r || p) && s(!0);
  }, [
    t,
    r,
    u,
    s,
    p,
    E,
    g,
    D,
    A
  ]);
  const h = () => {
    s(!0), T(), y({ type: null });
  }, C = {
    month: "short",
    day: "numeric"
  }, w = t && r ? `${t.toLocaleDateString(
    window.I18n.locale,
    C
  )} - ${r.toLocaleDateString(
    window.I18n.locale,
    C
  )}` : "", W = () => {
    const k = () => {
      if (i.type)
        switch (i.type) {
          case "min_stay":
            return /* @__PURE__ */ e.createElement(G, { minDays: o });
          case "max_stay":
            return /* @__PURE__ */ e.createElement(q, { maxDays: l });
          case "closed_to_arrival":
            return /* @__PURE__ */ e.createElement(j, null);
          case "closed_to_departure":
            return /* @__PURE__ */ e.createElement(Y, null);
          case "closed_to_departure_and_min_stay":
            return /* @__PURE__ */ e.createElement(H, { minDays: o });
          case "closed_to_departure_and_max_stay":
            return /* @__PURE__ */ e.createElement(F, { maxDays: l });
          case "time_limit":
            const S = i.customMessage;
            return S ? /* @__PURE__ */ e.createElement(L, null, S) : null;
          default:
            return null;
        }
    };
    return (!o || o <= 1) && !l && !i.type ? null : /* @__PURE__ */ e.createElement(
      "div",
      {
        className: a[`${n}--footer-warning`],
        "data-testid": "availability-warning"
      },
      k()
    );
  }, $ = /* @__PURE__ */ e.createElement("div", { className: f([a[`${n}--footer`]]) }, W(), /* @__PURE__ */ e.createElement("div", { className: a[`${n}--footer-actions`] }, /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      "data-testid": "resetButton",
      disabled: !(t || v),
      className: f([a[`${n}--reset-button`]]),
      onClick: h
    },
    I18n.t("booking_engine.search.reset")
  )));
  return /* @__PURE__ */ e.createElement(
    M,
    {
      className: f(a[`${n}--content`], {
        [a[`${n}--content-with-warning`]]: o > 1 || l || i.type !== null
      }),
      title: I18n.t("booking_engine.dates"),
      icon: /* @__PURE__ */ e.createElement(R, { "data-testid": "icon-calendar" }),
      subtitle: w,
      expand: u,
      setExpand: _,
      footer: $,
      isDisabled: !t || !r,
      childId: "dates-container"
    },
    /* @__PURE__ */ e.createElement(
      x,
      {
        setMinDays: I,
        setMaxDays: N,
        setWarning: y
      }
    )
  );
};
export {
  _e as DatesContainer
};
